angular
  .module('app')
  .component('huenewsAdminComponent', {
    template:
      '<div style="padding:16px 0"><iframe id="hnAdminFrame" ng-src="{{$ctrl.src}}" title="HueNews admin" ' +
      'style="width:100%;height:calc(100vh - 140px);min-height:600px;border:1px solid #e3e3e3;border-radius:8px"></iframe></div>',
    controller: function ($sce, $window, $element, authService) {
      var ORIGIN = 'https://huenews-huedata-0c6906420f44.herokuapp.com';
      var ctrl = this;
      ctrl.src = $sce.trustAsResourceUrl(ORIGIN + '/admin');
      // Hand the signed-in admin's huedata.ai session to the HueNews admin page.
      // The HueNews server verifies it against api.huedata.ai and only accepts admins.
      function send() {
        var f = $element[0].querySelector('#hnAdminFrame');
        if (f && f.contentWindow && authService.token) {
          f.contentWindow.postMessage({ type: 'hn-auth', token: authService.token }, ORIGIN);
        }
      }
      function onMsg(e) {
        if (e.origin === ORIGIN && e.data && e.data.type === 'hn-ready') send();
      }
      $window.addEventListener('message', onMsg);
      ctrl.$onDestroy = function () { $window.removeEventListener('message', onMsg); };
    },
  });
